import { render, staticRenderFns } from "./crmTags.vue?vue&type=template&id=43a73149&scoped=true"
import script from "./crmTags.vue?vue&type=script&lang=js"
export * from "./crmTags.vue?vue&type=script&lang=js"
import style0 from "./crmTags.vue?vue&type=style&index=0&id=43a73149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a73149",
  null
  
)

export default component.exports